/* istanbul ignore file */

export const FIELDS = {
  // property type
  channel: "channelCode",
  categoryType: "propertyCategoryTypeCode",
  exclusivityType: "listingExclusivityCode",
  propertyType: "propertyTypeCode",
  propertyGroupType: "propertyGroupTypeCode",
  isAuction: "isAuction",
  storey: "storeyCode",
  auctionDate: "auctionDate",
  isCoAgency: "isCoAgency",
  referenceNo: "listingRefNo",

  // location
  buildingName: "buildingName",
  commercialLot: "commercialLot",
  state: "state",
  city: "city",
  township: "township",
  townshipOther: "townshipOther",
  hasNoTownship: "hasNoTownship",
  postCode: "postCode",
  address: "address",
  block: "block",
  unit: "unit",
  floor: "floor",
  isHideUnitAndFloorForIProperty: "isHideUnitAndFloorForIProperty",
  hiddenAddress: "hiddenAddress",
  geolocation: "geolocation",
  propertyNotMatch: "propertyNotMatch",

  // property detail
  salePrice: "salePrice",
  rentPrice: "rentPrice",
  maintenancePrice: "maintenancePrice",
  saleableAreaMeasurement: "saleableAreaMeasurement",
  grossMeasurementUnits: "grossMeasurementUnits",
  builtArea: "builtArea",
  builtAreaLength: "builtAreaLength",
  builtAreaWidth: "builtAreaWidth",
  landArea: "landArea",
  landAreaLength: "landAreaLength",
  landAreaWidth: "landAreaWidth",
  legacyLandArea: "legacyLandArea",
  unitType: "unitType",
  orientation: "orientation",
  furnishing: "furnishings",
  bedrooms: "bedrooms",
  storageRooms: "storageRooms",
  bathrooms: "bathrooms",
  carpark: "carpark",
  tenure: "tenure",
  unexpiredYear: "unexpiredYear",
  titleType: "titleType",
  landTitleType: "landTitleType",
  occupancyStatus: "occupancyStatus",
  isBumiLot: "isBumiLot",
  availabilityDate: "availabilityDate",
  unitFeatures: "unitFeatures",
  buildingFacilities: "buildingFacilities",
  carparkNo: "carParkNo",
  // description
  description_gb: "description-en_GB",
  description_my: "description-ms_MY",

  // media
  images: "images",
  floorplans: "floorplans",
  photo360s: "photo360s",
  video: "video",
  isLiveTourAvailable: "isLiveTourAvailable",
  title_gb: "title-en_GB",

  // upgrade
  tier: "tier",
  saleTier: "sale" as "sale",
  rentTier: "rent" as "rent",
  contractId: "reaId" as "reaId",
  // extra flag
  isWithinGP: "isWithinGP",

  panoleh: "panoleh",

  isPostCrossListing: "isPostCrossListing",
};
